import { Comment, LoanStatus, LoanStatusView } from '@nemuru-eng/js-api-client';

export const useActivitySummary = () => {
  const ENDING_SUPPORT_STATUSES = [
    LoanStatus.STATUS_DOCS_APPROVED,
    LoanStatus.STATUS_EXPIRED,
    LoanStatus.STATUS_CANCELLED,
    LoanStatus.STATUS_CANCELLED_TEST,
    LoanStatus.STATUS_DESISTED,
    LoanStatus.STATUS_DENIED,
  ];

  const findLoanEndingSupportStatus = (loanStatuses: LoanStatusView) => {
    if (loanStatuses) {
      const filteredStatus = Object.values(loanStatuses.statuses).filter((item) =>
        ENDING_SUPPORT_STATUSES.includes(item?.status),
      );
      if (filteredStatus.length > 0) {
        filteredStatus.sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime());
      }
      return filteredStatus.length > 0 ? filteredStatus : undefined;
    }
  };

  const calculateNumberOfActions = (comments: Comment[]) => {
    const filteredArray = comments.filter((obj) => obj.channel !== 'api');
    return filteredArray.length;
  };
  return { findLoanEndingSupportStatus, calculateNumberOfActions };
};
